import React from 'react';
import { Alert, message, Modal } from 'antd';
import Container from '@/components/Container';
import { unLock, initialSettings } from '@/services/salary/initialSettings';
import SettingRow from './components/SettingRow';
import styles from './index.less';

const { confirm } = Modal;
const InitialSettings = () => {
  const handleShowInit = () => {
    confirm({
      title: '初始化关闭工资条管理页面查看密码吗？',
      centered: true,
      okText: '确认',
      cancelText: '取消',
      onOk: async () => {
        try {
          await initialSettings();
          message.success('操作成功');
        } catch (e) {
          console.error(e);
        }
      },
    });
  };
  const handleShowUnlock = () => {
    confirm({
      title: '确认解除工资条管理页面的锁定状态？',
      centered: true,
      okText: '确认',
      cancelText: '取消',
      onOk: async () => {
        try {
          await unLock();
          message.success('操作成功');
        } catch (e) {
          console.error(e);
        }
      },
    });
  };

  return (
    <Container breStates isSplitBar>
      <div className={styles['initial-tips']}>
        <Alert
          type="info"
          message="1.初始化设置后，工资条管理页面将初始化为不需要录入密码即可查看；
2.可解除工资条管理页面当天由于连续输入多次输入错误引起的页面锁定，若当前未设置需录入密码查看，则实际操作无效；"
          showIcon
        />
      </div>
      <SettingRow text="工资条隐私设置初始化：" actionText="更新" onClick={handleShowInit} />
      <SettingRow text="工资条管理页面锁定解除：" actionText="解除" onClick={handleShowUnlock} />
    </Container>
  );
};

export default InitialSettings;
